import React, { Component } from "react";
import LangContext from "../../contextProvider/LangContext";
import PageToolbar from "../../components/PageToolbar";
import GenericTable from "../../components/GenericTable";
import TableIDs from "../../data/TableIDs";
import GenericSelector from "../../components/GenericSelector";
import { Input, InputNumber } from "antd";
import TableLineIcons from "../../components/TableLineIcons";

class StatusTranslation extends Component {

    constructor(props) {
        super(props)

        this.id = "EXTERNAL_ORDER_STATUS_TRANSLATION"

        this.api = {
            get: "get_external_order_status_translation",
            create: "create_external_order_status_translation",
            edit: "edit_external_order_status_translation",
        }

        this.selectors = [
            { id: TableIDs.genericSelectorExternalOrderSuppliers, api: "external_orders_supplier_logo_list" }
        ]

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };
        this.selectors.forEach((x) => {
            if (props.data[x.id] === undefined) props.data[x.id] = { ...props.data.genericSelector };
        })

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(21402);
    }

    render() {


        const gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: "ltr"
            padding: "2% 2% 2% 2%",
        };

        const { editedRecord, editing } = this.props.data[this.id];

        const onChange = (data) => { this.props.dataActions.genericDataSetEdit(this.id, data) }

        const renderSupplier = (t, r) => {

            return (<GenericSelector
                {...this.props}
                {...this.selectors[0]}
                value={r.key == editing && editing == 0 ? editedRecord.nSupplierId : t}
                onChange={e => { onChange({ nSupplierId: e }) }}
                disabled={r.key != editing || editing != 0}
            />)
        }

        const renderSystemStatus = (t, r) => r.key == editing && editing == 0 ? (<InputNumber value={editedRecord.nSystemStatus} onChange={e => { onChange({ nSystemStatus: e }) }} />) : t;
        const renderSupplierStatus = (t, r) => r.key == editing ? (<InputNumber value={editedRecord.nSupplierStatus} onChange={e => { onChange({ nSupplierStatus: e }) }} />) : t;
        const renderSupplierStatusAlternative = (t, r) => r.key == editing ? (<Input value={editedRecord.nSupplierStatusAlternative} onChange={e => { onChange({ nSupplierStatusAlternative: e.target.value }) }} />) : t;
        const renderEdit = (t, r) => {
            if (r.key == editing) {
                return (<TableLineIcons
                    onCheck={() => {
                        let setApi = editing == 0 ? this.api.create : this.api.edit
                        this.props.dataActions.genericDataSaveEdit(this.id, this.props.user.companyCode, this.props.user.token, setApi, this.api.get)
                    }}
                    onClose={() => {
                        if (editing == 0) this.props.dataActions.genericDataCancelInlineCreate(this.id);
                        else this.props.dataActions.genericDataCancelEditing(this.id);
                    }}
                />)
            } else {
                return (<TableLineIcons
                    onEdit={() => { this.props.dataActions.genericDataStartEditing(this.id, r.key, r.index) }}
                />);
            }
        }

        let userEditPermission = this.props.data[TableIDs.pseudoSelectorUIcomponentsModules].dataset?.find(f => f.code === '537') ? true : false
        let addButton = userEditPermission ? () => { this.props.dataActions.genericDataStartInlineCreate(this.id) } : undefined
        let columns = [
            { title: gt(21407), key: "nSupplierId", dataIndex: "nSupplierId", width: "25%", render: renderSupplier },
            { title: gt(21408), key: "nSystemStatus", dataIndex: "nSystemStatus", width: "15%", render: renderSystemStatus },
            { title: gt(21409), key: "nSupplierStatus", dataIndex: "nSupplierStatus", width: "15%", render: renderSupplierStatus },
            { title: gt(21410), key: "nSupplierStatusAlternative", dataIndex: "nSupplierStatusAlternative", width: "30%", render: renderSupplierStatusAlternative },
        ]
        if (userEditPermission) columns.push({ title: gt(21411), key: "editCol", width: "10%", render: renderEdit })

        return (<div style={divStyle}>
            <GenericTable {...this.props}
                title={gt(21402)}
                id={this.id}
                getApi={this.api.get}
                addButton={addButton}
                columns={columns}
                pagination={{ pageSize: 15 }} />
        </div>)
    }
}

export default StatusTranslation;